import { render } from "./InternetRiepilogue.vue?vue&type=template&id=37aba772"
import script from "./InternetRiepilogue.vue?vue&type=script&lang=js"
export * from "./InternetRiepilogue.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "37aba772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37aba772', script)) {
    api.reload('37aba772', script)
  }
  
  module.hot.accept("./InternetRiepilogue.vue?vue&type=template&id=37aba772", () => {
    api.rerender('37aba772', render)
  })

}

script.__file = "src/views/services/modules/internet/pills/InternetRiepilogue.vue"

export default script